<template>
  <div class="home-page">
    <Header></Header>
    <div class="chances-top disflex crfff ac">
      <div @click="back">
        <img class="nav-icon-left" src="../../static/images/back.png" width="20"/>
        <div>{{ $t('Back') }}</div>
      </div>
    </div>
    <div class="mission-content crfff">
      <div class="fs50 mt50 ac">{{productDetail.title}}</div>
      <div class="css-1asaykn mt50">
        <div class="resume-selection mt50">
          <div class="selection-title fs32 fw7 mb20">{{ $t('Template') }}</div>
          <div class="template-list-wrapper">
            <div class="template-list">
              <div v-for="item in templates" :key="item.code" class="template-card" :class="{active: selectedTemplate && selectedTemplate.code == item.code}" @click="selectTemplate(item)">
                <div class="template-img-box">
                  <img :src="item.image" class="template-img" />
                  <div class="template-name-overlay">{{ item.name }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="selection-header mt50 mb20">
            <div class="selection-title fs32 fw7">{{ $t('TemplateColor') }}</div>
            <div class="expand-btn" @click="showAllColors = !showAllColors">
              <i class="arrow-icon" :class="{up: showAllColors}"></i>
            </div>
          </div>
          <div class="color-grid" :class="{expanded: showAllColors}">
            <div v-for="item in colors" :key="item.color" class="color-circle-wrapper" @click="selectColor(item)">
              <div class="color-circle" :style="{backgroundColor: item.color}" :class="{active: selectedColor == item.color}"></div>
            </div>
          </div>

          <div class="selection-header mt50 mb20">
            <div class="selection-title fs32 fw7">{{ $t('Background') }}</div>
            <div class="expand-btn" @click="showAllBackgrounds = !showAllBackgrounds">
              <i class="arrow-icon" :class="{up: showAllBackgrounds}"></i>
            </div>
          </div>
          <div class="color-grid" :class="{expanded: showAllBackgrounds}">
            <div v-for="item in backgrounds" :key="item.color" class="color-circle-wrapper" @click="selectBackground(item)">
              <div class="color-circle" :style="{backgroundColor: item.color}" :class="{active: selectedBackground == item.color}"></div>
            </div>
          </div>
        </div>

        <div class="resume-form-container mt50">
          <!-- 基本信息 -->
          <div class="form-section">
            <div class="section-title-wrap mb30">
              <span class="section-title-line"></span>
              <div class="section-title fs32 fw7">{{ $t('BasicInfo') }}</div>
            </div>

            <div class="avatar-upload-section mb40 flex ac">
              <div class="avatar-upload-btn-wrap">
                <button class="avatar-btn">
                  <img src="../../static/images/transparent.png" width="20" class="mr10">
                  {{ $t('UploadAvatar') }}
                </button>
                <input accept="image/*" class="avatar-file-input" type="file" @change="convertToBase64_v2">
              </div>
              <div class="avatar-preview ml30" v-if="imageBase64">
                <img :src="imageBase64" class="avatar-thumb" />
                <div class="thumb-label fs20 cr999 mt10 ac">{{ $t('ResumePhoto') }}</div>
              </div>
            </div>

            <div class="form-group">
              <input type="text" class="resume-input" :placeholder="$t('Full Name')" v-model="resumeContent.name">
              <input type="text" class="resume-input" :placeholder="$t('Job Role')" v-model="resumeContent.role">
              <input type="email" class="resume-input" :placeholder="$t('Email')" v-model="resumeContent.email">
              <input type="tel" class="resume-input" :placeholder="$t('Phone Number')" v-model="resumeContent.phone">
              <input type="text" class="resume-input" :placeholder="$t('Address')" v-model="resumeContent.address">
              <textarea class="resume-textarea" :placeholder="$t('Summary')" v-model="resumeContent.summary"></textarea>
            </div>
          </div>

          <!-- 教育经历 -->
          <div class="form-section mt60">
            <div class="section-title-wrap mb30">
              <span class="section-title-line"></span>
              <div class="section-title fs32 fw7">{{ $t('Education') }}</div>
            </div>
            <div v-for="(edu, index) in resumeContent.education" :key="'edu'+index" class="form-item-box mb30">
              <div class="remove-btn-wrap" v-if="resumeContent.education.length > 1" @click="removeEducation(index)">
                <span class="remove-icon">×</span>
              </div>
              <input type="text" class="resume-input" :placeholder="$t('Institution')" v-model="edu.institution">
              <input type="text" class="resume-input" :placeholder="$t('Degree')" v-model="edu.degree">
              <div class="flex ac gap20">
                <input type="text" class="resume-input flex1" :placeholder="$t('Start Date (YYYY-MM-DD)')" v-model="edu.start_date">
                <input type="text" class="resume-input flex1" :placeholder="$t('End Date (YYYY-MM-DD)')" v-model="edu.end_date" :disabled="edu.present" :style="{opacity: edu.present ? 0.5 : 1}">
              </div>
              <div class="flex ac mt20">
                <div class="checkbox-wrap flex ac" @click="edu.present = !edu.present">
                  <div class="custom-checkbox" :class="{checked: edu.present}"></div>
                  <span class="ml15 fs24 cr-eee">{{ $t('Currently Studying Here') }}</span>
                </div>
              </div>
              <textarea class="resume-textarea mt20" style="height: 1.5rem;" :placeholder="$t('Short Description')" v-model="edu.short_description"></textarea>

              <!-- Achievements -->
              <div class="sub-section mt30">
                <div class="section-header mb10">
                  <div class="fs24 fw7 cr999 uppercase-label">{{ $t('Achievements') }}</div>
                  <div class="add-sub-btn" @click="addAchievement(index)">+ {{ $t('Add') }}</div>
                </div>
                <div v-for="(ach, achIndex) in edu.achievements" :key="'ach'+achIndex" class="flex ac mt15">
                  <input type="text" class="resume-input flex1 mt0" :placeholder="$t('Achievement text')" v-model="ach.text">
                  <div class="ml20 remove-sub-icon" v-if="edu.achievements.length > 1" @click="removeAchievement(index, achIndex)">×</div>
                </div>
              </div>
            </div>
            <div class="add-btn-long mt20" @click="addEducation">
              <span class="fs32 mr10">+</span> {{ $t('Add Education') }}
            </div>
          </div>

          <!-- 工作经历 -->
          <div class="form-section mt60">
            <div class="section-title-wrap mb30">
              <span class="section-title-line"></span>
              <div class="section-title fs32 fw7">{{ $t('Employment') }}</div>
            </div>
            <div v-for="(emp, index) in resumeContent.employment" :key="'emp'+index" class="form-item-box mb30">
              <div class="remove-btn-wrap" v-if="resumeContent.employment.length > 1" @click="removeEmployment(index)">
                <span class="remove-icon">×</span>
              </div>
              <input type="text" class="resume-input" :placeholder="$t('Job Title')" v-model="emp.title">
              <input type="text" class="resume-input" :placeholder="$t('Company')" v-model="emp.company">
              <div class="flex ac gap20">
                <input type="text" class="resume-input flex1" :placeholder="$t('Start Date (YYYY-MM-DD)')" v-model="emp.start_date">
                <input type="text" class="resume-input flex1" :placeholder="$t('End Date (YYYY-MM-DD)')" v-model="emp.end_date" :disabled="emp.present" :style="{opacity: emp.present ? 0.5 : 1}">
              </div>
              <div class="flex ac mt20">
                <div class="checkbox-wrap flex ac" @click="emp.present = !emp.present">
                  <div class="custom-checkbox" :class="{checked: emp.present}"></div>
                  <span class="ml15 fs24 cr-eee">{{ $t('Currently Working Here') }}</span>
                </div>
              </div>
              <textarea class="resume-textarea mt20" style="height: 1.5rem;" :placeholder="$t('Short Description')" v-model="emp.short_description"></textarea>

              <!-- Responsibilities -->
              <div class="sub-section mt30">
                <div class="section-header mb10">
                  <div class="fs24 fw7 cr999 uppercase-label">{{ $t('Responsibilities') }}</div>
                  <div class="add-sub-btn" @click="addResponsibility(index)">+ {{ $t('Add') }}</div>
                </div>
                <div v-for="(res, resIndex) in emp.responsibilities" :key="'res'+resIndex" class="flex ac mt15">
                  <input type="text" class="resume-input flex1 mt0" :placeholder="$t('Responsibility text')" v-model="res.text">
                  <div class="ml20 remove-sub-icon" v-if="emp.responsibilities.length > 1" @click="removeResponsibility(index, resIndex)">×</div>
                </div>
              </div>
            </div>
            <div class="add-btn-long mt20" @click="addEmployment">
              <span class="fs32 mr10">+</span> {{ $t('Add Employment') }}
            </div>
          </div>

          <!-- 技能 -->
          <div class="form-section mt60">
            <div class="section-title-wrap mb30">
              <span class="section-title-line"></span>
              <div class="section-title fs32 fw7">{{ $t('Skills') }}</div>
            </div>
            <div v-for="(skill, index) in resumeContent.skills" :key="'skill'+index" class="form-item-box mb30">
              <div class="remove-btn-wrap" v-if="resumeContent.skills.length > 1" @click="removeSkill(index)">
                <span class="remove-icon">×</span>
              </div>
              <div class="flex ac gap20">
                <input type="text" class="resume-input flex1 mt0" :placeholder="$t('Skill Name')" v-model="skill.name">
                <div class="resume-select-wrap">
                  <select class="resume-select skill-level-select" v-model="skill.proficiency">
                    <option value="Beginner">Beginner</option>
                    <option value="Intermediate">Intermediate</option>
                    <option value="Advanced">Advanced</option>
                    <option value="Expert">Expert</option>
                  </select>
                  <i class="select-arrow"></i>
                </div>
              </div>
            </div>
            <div class="add-btn-long mt20" @click="addSkill">
              <span class="fs32 mr10">+</span> {{ $t('Add Skill') }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ac mt60 mb40">
      <button class="generate-btn" @click="uploadImage">
        <strong>{{ $t('Generate') }}</strong>
      </button>
    </div>
    <div class="flex chances-info-bar mt30" style="justify-content: space-between;">
      <div class="score-badge">
        <span class="fs24">{{$t('ChancesLeft')}}</span>
        <span class="fs32 fw7 ml10">{{score}}</span>
      </div>
      <button class="buy-btn" @click="goPurchaseChances">
        <span>{{ $t('BuyChances') }}</span>
        <img src="../../static/images/buy.png" class="buy-icon" >
      </button>
    </div>
    <Dialog ref="imgDialog" :iscloseMask="true" :modalFoot="false" style="min-height: 300px;" title="" type="alert"
            width="100">
      <div slot="mdBox" class="alert-modal">
        <div class="close" style="text-align: right;margin: 0 auto;font-size: 50px;" @click="closeTmgDialog">×</div>
        <div v-if="imageShow" class="image ac">
          <div class="" style="font-size:0.3rem;margin-bottom: 20px;">{{ $t('downTips1') }}</div>
          <img v-if="isShowResult==1" :src="detail.url" style="width:80%;"/>
          <img v-if="isShowResult==2" :src="detail.original_url" style="width:80%;"/>

          <div class="tab mt50">
            <span :class="{'active':isShowResult==1}" @click="getResult(1)">{{ $t('Result') }}</span>
            <span :class="{'active':isShowResult==2}" @click="getResult(2)">{{ $t('Original') }}</span>
          </div>
          <div class="img-tools">
            <div class="ac disflex mt30">
              <div class="input-item">
                <div v-if="isShowResult==1" class="input-item2">
                  <input v-model="detail.url" class="input" disabled placeholder="" type="">
                  <img v-if="detail.url" id="copycode" :data-clipboard-text="detail.url"
                       src="../../static/images/Copy.png" style="margin-left: 10px;width: 1rem" @click="copy"/>
                </div>
                <div v-if="isShowResult==2" class="input-item2">
                  <input v-model="detail.original_url" class="input" disabled placeholder="" type="">
                  <img v-if="detail.original_url" id="copycode" :data-clipboard-text="detail.original_url"
                       src="../../static/images/Copy.png" style="margin-left: 10px;width: 1rem" @click="copy"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>


    <Dialog ref="processDialog" :iscloseMask="true" :modalFoot="false" style="min-height: 300px;" title="" type="alert"
            width="100">
      <div slot="mdBox" class="alert-modal ac">
        <div class="fs33 mt50 ac">{{ processMsg }}</div>
        <button class="button mt30" @click="closeProcessDialog">{{ $t('OK') }}</button>
      </div>
    </Dialog>

  </div>
</template>
<script>
import Header from '../components/Header'
import Clipboard from 'clipboard';
import Dialog from '../components/dialog'

export default {
  components: {
    Header, Dialog
  },
  data() {

    return {
      detail: {},
      isShow: false,
      value: 50,
      imageShow: false,
      imageBase64: null,
      imageTpye: '',
      withScratch: false,
      isImgModel: false,
      isImage: true,
      score: 0,
      isShowResult: 1,
      processMsg: "",
      isType: '',
      productDetail:{},
      templates: [],
      selectedTemplate: null,
      colors: [],
      selectedColor: '',
      selectedColorTitle: '',
      backgrounds: [],
      selectedBackground: '',
      selectedBackgroundTitle: '',
      showAllColors: false,
      showAllBackgrounds: false,
      resumeContent: {
        name: '',
        role: '',
        email: '',
        phone: '',
        address: '',
        summary: '',
        employment: [
          {
            title: '',
            company: '',
            start_date: '',
            end_date: '',
            present: true,
            short_description: '',
            responsibilities: [
              { text: '' }
            ],
          }
        ],
        skills: [
          {
            name: '',
            proficiency: 'Expert',
            display_proficiency: true,
          }
        ],
        education: [
          {
            degree: '',
            institution: '',
            start_date: '',
            end_date: '',
            present: true,
            short_description: '',
            achievements: [
              { text: '' }
            ],
          }
        ],
      }
    }
  },
  watch: {},
  computed: {},
  mounted() {
    let that = this;
  },
  created() {
    this.getHome();
    this.getTemplates();
  },
  methods: {
    selectTemplate(item) {
      this.selectedTemplate = item;
    },
    selectColor(item) {
      this.selectedColor = item.color;
      this.selectedColorTitle = item.title;
    },
    selectBackground(item) {
      this.selectedBackground = item.color;
      this.selectedBackgroundTitle = item.title;
    },
    addEmployment() {
      this.resumeContent.employment.push({
        title: '',
        company: '',
        start_date: '',
        end_date: '',
        present: true,
        short_description: '',
        responsibilities: [
          { text: '' }
        ],
      });
    },
    removeEmployment(index) {
      this.resumeContent.employment.splice(index, 1);
    },
    addResponsibility(empIndex) {
      this.resumeContent.employment[empIndex].responsibilities.push({ text: '' });
    },
    removeResponsibility(empIndex, resIndex) {
      this.resumeContent.employment[empIndex].responsibilities.splice(resIndex, 1);
    },
    addSkill() {
      this.resumeContent.skills.push({
        name: '',
        proficiency: 'Expert',
        display_proficiency: true,
      });
    },
    removeSkill(index) {
      this.resumeContent.skills.splice(index, 1);
    },
    addEducation() {
      this.resumeContent.education.push({
        degree: '',
        institution: '',
        start_date: '',
        end_date: '',
        present: true,
        short_description: '',
        achievements: [
          { text: '' }
        ],
      });
    },
    removeEducation(index) {
      this.resumeContent.education.splice(index, 1);
    },
    addAchievement(eduIndex) {
      this.resumeContent.education[eduIndex].achievements.push({ text: '' });
    },
    removeAchievement(eduIndex, achIndex) {
      this.resumeContent.education[eduIndex].achievements.splice(achIndex, 1);
    },
    getTemplates() {
      let that = this;
      that.$api.get('/api/resume/templates', null, r => {
        that.$parent.returnCode(r, function () {
          that.templates = r.data.templates;
          if (that.templates && that.templates.length > 0) {
            that.selectedTemplate = that.templates[0];
          }
          that.colors = r.data.template_colors;
          if (that.colors && that.colors.length > 0) {
            that.selectedColor = that.colors[0].color;
            that.selectedColorTitle = that.colors[0].title;
          }
          that.backgrounds = r.data.background_colors;
          if (that.backgrounds && that.backgrounds.length > 0) {
            that.selectedBackground = that.backgrounds[0].color;
            that.selectedBackgroundTitle = that.backgrounds[0].title;
          }
        });
      })
    },
    getClick(item) {
      this.isType = item.key
    },
    getResult(type) {
      this.isShowResult = type
    },
    copy(item) {
      var clipboard = new Clipboard("#copycode");
      clipboard.on("success", (e) => {
        this.$utils.alertText(this.$t('CopySucceeded'));
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        //console.log("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    back() {
      this.$router.go(-1);
    },
    getHome() {
      let that = this;
      that.$api.get('/api/user/info', null, r => {
        that.$parent.returnCode(r, function () {
          that.score = r.data.score
        });
      })
    },

    getCharactersAfter(str, charToFind) {
      var index = str.indexOf(charToFind);
      if (index !== -1) {
        return str.slice(index + 1);
      }
      return ''; // 如果字符未找到，返回空字符串
    },
    convertToBase64(event) {
      const file = event.target.files[0];
      this.imageTpye = this.getCharactersAfter(file.type, '/');
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageBase64 = e.target.result;
          // 在这里可以将Base64字符串上传到服务器
          // this.uploadImage(this.imageBase64);
        };
        reader.readAsDataURL(file);
      }
    },
    convertToBase64_v2(event) {
      let that = this;
      const file = event.target.files[0];
      if (!file) return;
      // 原始大小（单位：KB）
      const originSizeKB = (file.size / 1024).toFixed(2);
      console.log("原始文件大小:", originSizeKB, "KB");
      // 1. 文件大小限制（5MB）
      const maxSize = 5 * 1024 * 1024; // 5MB
      if (file.size > maxSize) {
        that.$refs.processDialog.showMaskFun();
        that.processMsg = this.$t('pic_size_limit')
        event.target.value = '';
        return;
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.src = e.target.result;
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          // 2. 缩放尺寸
          const maxWidth = 800;
          const maxHeight = 800;
          let {width, height} = img;
          if (width > height) {
            if (width > maxWidth) {
              height *= maxWidth / width;
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width *= maxHeight / height;
              height = maxHeight;
            }
          }
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);
          // 3. PNG 自动转 JPEG
          let outputType = file.type.toLowerCase() === 'image/png' ? 'image/jpeg' : file.type;
          // 4. 压缩导出（JPEG 质量 0.7）
          this.imageBase64 = canvas.toDataURL(outputType, 0.7);
          // 5. 设置上传类型
          this.imageTpye = outputType.split('/')[1]; // e.g. "jpeg"
          // 计算压缩后的大小
          const compressedSize = this.base64Size(this.imageBase64);
          console.log("压缩后文件大小:", (compressedSize / 1024).toFixed(2), "KB");
        };
      };

      reader.readAsDataURL(file);
      event.target.value = '';
    },
    uploadImage() {
      let that = this
      if (!that.imageBase64) {
        that.$utils.alertText(that.$t('uploadTips'), 100);
        return;
      }

      // 深拷贝 content 以免修改原始表单数据
      let content = JSON.parse(JSON.stringify(that.resumeContent));

      // 强制转换布尔值，防止某些浏览器或组件将其变为字符串
      if (content.employment) {
        content.employment.forEach(item => {
          item.present = !!item.present;
        });
      }
      if (content.education) {
        content.education.forEach(item => {
          item.present = !!item.present;
        });
      }
      if (content.skills) {
        content.skills.forEach(item => {
          item.display_proficiency = !!item.display_proficiency;
        });
      }

      let data = {
        avatar: {
          type: that.imageTpye,
          content: that.imageBase64
        },
        content: content,
        style: {
          template: that.selectedTemplate ? that.selectedTemplate.code : '',
          template_color: that.selectedColorTitle ? that.selectedColorTitle.toLowerCase() : '',
          background_color: that.selectedBackgroundTitle ? that.selectedBackgroundTitle.toLowerCase() : '',
        }
      }
      that.$parent.loadModal(true);
      that.$api.post('/api/resume/create', data, r => {
        that.$parent.loadModal(false);
        that.getHome()
        if (r.code == 1 && r.data.status) {
          this.$router.push({
            path: '/ai_Resume_detail',
            query: {
              url: r.data.url,
              name: that.resumeContent.name
            }
          })
          return;
        }
        if (r.code == 0) {
          that.$refs.processDialog.showMaskFun();
          that.processMsg = r.msg
          return;
        }
        that.$parent.returnCode(r, function () {
          that.$refs.imgDialog.showMaskFun();
          that.imageShow = true
          that.detail = r.data
        });
      })
    },
    getImage() {
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = this.detail.url
      console.log(link.href)
      // link.target = '_blank'
      link.setAttribute('download', '文件名称')
      document.body.appendChild(link)
      link.click()
      window.open(this.detail.url, '_blank')

    },
    closeTmgDialog() {
      this.detail = {}
      this.$refs.imgDialog.closeMask();
    },
    closeProcessDialog() {
      this.processMsg = ""
      this.$refs.processDialog.closeMask();
    },
    goPurchaseChances() {
      this.$router.push({path: '/purchaseChances'})
    },
    // 辅助方法：计算 base64 图片大小
    base64Size(base64) {
      let str = base64.split(',')[1]; // 去掉前缀 data:image/jpeg;base64,
      let eqIndex = str.indexOf('=');
      if (eqIndex > 0) {
        str = str.substring(0, eqIndex); // 去掉填充字符
      }
      let length = str.length;
      return length * 3 / 4; // 得到字节数
    }
  }
}
</script>
<style scoped>
.resume-selection {
  padding: 0 0.3rem;
}
.template-list-wrapper {
  overflow-x: auto;
  padding: 0.1rem 0 0.3rem;
  -webkit-overflow-scrolling: touch;
}
.template-list {
  display: flex;
  gap: 0.35rem;
  width: max-content;
  padding: 0 0.1rem;
}
.template-card {
  width: 2.4rem;
  border-radius: 0.2rem;
  overflow: hidden;
  border: 2px solid rgba(255, 255, 255, 0.05);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  background: rgba(255, 255, 255, 0.03);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}
.template-card.active {
  border-color: #1A4BA9;
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(26, 75, 169, 0.4);
}
.template-card.active::after {
  content: '✓';
  position: absolute;
  top: 0.1rem;
  right: 0.1rem;
  width: 0.4rem;
  height: 0.4rem;
  background: #1A4BA9;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.24rem;
  font-weight: bold;
  z-index: 2;
}
.template-img-box {
  width: 100%;
  aspect-ratio: 1 / 1.414;
  background: #2a2a2a;
  position: relative;
}
.template-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.template-name-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
  color: #fff;
  font-size: 0.24rem;
  text-align: center;
  padding: 0.15rem 0 0.1rem;
  font-weight: 500;
}

.selection-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.expand-btn {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 50%;
  width: 0.5rem;
  height: 0.5rem;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
}
.expand-btn:active {
  background: rgba(255, 255, 255, 0.15);
}
.arrow-icon {
  display: inline-block;
  width: 0.14rem;
  height: 0.14rem;
  border-right: 2px solid rgba(255, 255, 255, 0.6);
  border-bottom: 2px solid rgba(255, 255, 255, 0.6);
  transform: rotate(45deg);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  margin-top: -0.04rem;
}
.arrow-icon.up {
  transform: rotate(-135deg);
  margin-top: 0.08rem;
}

.color-grid {
  display: grid;
  grid-template-rows: repeat(1, 1fr);
  grid-auto-flow: column;
  overflow-x: auto;
  gap: 0.4rem 0.3rem;
  padding: 0.2rem 0.1rem 0.3rem;
  width: 100%;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-overflow-scrolling: touch;
}
.color-grid.expanded {
  grid-template-rows: repeat(3, 1fr);
}

.color-circle-wrapper {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
  padding: 0.05rem;
}
.color-circle {
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s;
  box-sizing: border-box;
  position: relative;
}
.color-circle.active {
  transform: scale(1.1);
  border-color: #fff;
  box-shadow: 0 0 15px rgba(255, 255, 255, 0.3);
}
.color-circle.active::after {
  content: '';
  position: absolute;
  top: -0.1rem;
  left: -0.1rem;
  right: -0.1rem;
  bottom: -0.1rem;
  border: 2px solid #1A4BA9;
  border-radius: 50%;
}

/* Background grid might need different circle size or padding */
.selection-title.mt50 {
  margin-top: 0.5rem;
}

/* 新增表单样式 */
.section-title-wrap {
  display: flex;
  align-items: center;
  position: relative;
}
.section-title-line {
  width: 0.08rem;
  height: 0.35rem;
  background: #1A4BA9;
  border-radius: 0.04rem;
  margin-right: 0.2rem;
}
.section-title {
  color: #fff;
  letter-spacing: 0.02rem;
}
.mb40 { margin-bottom: 0.4rem; }
.mt60 { margin-top: 0.6rem; }
.uppercase-label {
  text-transform: uppercase;
  letter-spacing: 0.05rem;
  opacity: 0.8;
}

.avatar-upload-section {
  padding: 0.2rem;
  background: rgba(255, 255, 255, 0.02);
  border-radius: 0.2rem;
}
.avatar-upload-btn-wrap {
  position: relative;
  overflow: hidden;
  display: inline-block;
}
.avatar-btn {
  background: rgba(26, 75, 169, 0.15);
  border: 1px dashed rgba(26, 75, 169, 0.5);
  color: #fff;
  padding: 0.25rem 0.45rem;
  border-radius: 0.15rem;
  font-size: 0.28rem;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s;
}
.avatar-btn:active {
  background: rgba(26, 75, 169, 0.3);
  transform: scale(0.98);
}
.avatar-file-input {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.avatar-thumb {
  width: 1.3rem;
  height: 1.3rem;
  border-radius: 0.15rem;
  object-fit: cover;
  border: 2px solid rgba(26, 75, 169, 0.3);
  display: block;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
}

.resume-form-container {
  padding: 0 0.3rem;
  text-align: left;
}
.resume-input, .resume-select {
  width: 100%;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 0.15rem;
  padding: 0 0.3rem !important;
  color: #fff;
  font-size: 0.28rem;
  box-sizing: border-box;
  outline: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  height: 0.9rem !important;
  line-height: 0.9rem !important;
  margin: 0 !important;
}
.resume-input {
  margin-top: 0.25rem !important;
}
.mt0 { margin-top: 0 !important; }

.resume-input:focus, .resume-select:focus {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(26, 75, 169, 0.8);
  box-shadow: 0 0 0 2px rgba(26, 75, 169, 0.2);
}
.resume-textarea {
  width: 100%;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 0.15rem;
  color: #fff;
  margin-top: 0.25rem;
  font-size: 0.28rem;
  box-sizing: border-box;
  outline: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  height: 2.2rem;
  padding: 0.25rem 0.3rem !important;
  resize: none;
  line-height: 1.5;
}
.resume-select-wrap {
  position: relative;
  flex-shrink: 0;
  width: 2.8rem;
}
.resume-select {
  appearance: none !important;
  -webkit-appearance: none !important;
  padding-right: 0.7rem !important;
  background-color: rgba(255, 255, 255, 0.05);
  background-image: none !important;
  cursor: pointer;
}
.select-arrow {
  position: absolute;
  right: 0.3rem;
  top: 50%;
  width: 0.14rem;
  height: 0.14rem;
  border-right: 2px solid rgba(255, 255, 255, 0.8);
  border-bottom: 2px solid rgba(255, 255, 255, 0.8);
  transform: translateY(-70%) rotate(45deg);
  pointer-events: none;
  transition: all 0.3s;
}
.resume-select:focus + .select-arrow {
  transform: translateY(-30%) rotate(-135deg);
  border-color: #1A4BA9;
}
.resume-select option {
  background-color: #1a1a1a;
  color: #fff;
}
.skill-level-select {
  width: 100% !important;
  margin-top: 0 !important;
  font-size: 0.28rem !important;
}

/* Checkbox Styles */
.checkbox-wrap {
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}
.custom-checkbox {
  width: 0.36rem;
  height: 0.36rem;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 0.08rem;
  position: relative;
  transition: all 0.2s;
  background: rgba(255, 255, 255, 0.05);
}
.custom-checkbox.checked {
  background: #1A4BA9;
  border-color: #1A4BA9;
}
.custom-checkbox.checked::after {
  content: '';
  position: absolute;
  left: 0.1rem;
  top: 0.03rem;
  width: 0.1rem;
  height: 0.18rem;
  border: solid white;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}
.ml15 { margin-left: 0.15rem; }
.cr-eee { color: #eee; }

.form-item-box {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.05);
  padding: 0.4rem 0.35rem;
  border-radius: 0.25rem;
  position: relative;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}
.remove-btn-wrap {
  position: absolute;
  right: -0.15rem;
  top: -0.15rem;
  width: 0.5rem;
  height: 0.5rem;
  background: #ff4d4f;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(255, 77, 79, 0.4);
  cursor: pointer;
  z-index: 5;
  transition: all 0.2s;
}
.remove-btn-wrap:active {
  transform: scale(0.9);
}
.remove-icon {
  color: #fff;
  font-size: 0.36rem;
  font-weight: bold;
}

.add-btn-long {
  width: 100%;
  border: 1px dashed rgba(26, 75, 169, 0.6);
  background: rgba(26, 75, 169, 0.05);
  color: #fff;
  padding: 0.25rem;
  border-radius: 0.15rem;
  text-align: center;
  font-size: 0.28rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
}
.add-btn-long:active {
  background: rgba(26, 75, 169, 0.15);
  transform: scale(0.99);
}

.sub-section {
  background: rgba(0, 0, 0, 0.15);
  padding: 0.25rem;
  border-radius: 0.15rem;
  border: 1px solid rgba(255, 255, 255, 0.03);
}
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.add-sub-btn {
  color: #1A4BA9;
  font-size: 0.24rem;
  font-weight: 700;
  cursor: pointer;
  padding: 0.05rem 0.15rem;
  background: rgba(26, 75, 169, 0.1);
  border-radius: 0.08rem;
}
.remove-sub-icon {
  color: rgba(255, 77, 79, 0.6);
  font-size: 0.45rem;
  cursor: pointer;
  line-height: 1;
}
.mt15 { margin-top: 0.15rem; }
.mb10 { margin-bottom: 0.1rem; }
.mb30 { margin-bottom: 0.3rem; }

/* Bottom Buttons */
.generate-btn {
  width: 85%;
  height: 0.9rem;
  background: linear-gradient(135deg, #1A4BA9 0%, #0d2e6e 100%);
  color: #fff;
  border-radius: 0.45rem;
  border: none;
  font-size: 0.32rem;
  font-weight: 700;
  box-shadow: 0 6px 20px rgba(26, 75, 169, 0.4);
  cursor: pointer;
  transition: all 0.3s;
}
.generate-btn:active {
  transform: scale(0.96);
  box-shadow: 0 2px 10px rgba(26, 75, 169, 0.4);
}
.chances-info-bar {
  display: flex;
  width: calc(100% - 0.6rem);
  margin: 0 auto 0.4rem;
  background: rgba(255, 255, 255, 0.05);
  padding: 0.12rem 0.22rem;
  border-radius: 0.5rem;
  align-items: center;
  gap: 0.14rem;
}
.score-badge {
  display: flex;
  align-items: center;
  color: #fff;
  min-width: 0;
  flex: 1 1 auto;
  white-space: nowrap;
  overflow: hidden;
}
.score-badge span {
  white-space: nowrap;
}
.score-badge span:first-child {
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}
.score-badge .fs24 {
  line-height: 2.35;
  padding: 0.02rem 0;
}
.buy-btn {
  background: #1A4BA9;
  border: none;
  color: #fff;
  padding: 0.12rem 0.24rem;
  border-radius: 0.3rem;
  font-size: 0.24rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(26, 75, 169, 0.3);
  -webkit-tap-highlight-color: transparent;
  flex: 0 1 48%;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
}
.buy-btn span {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.buy-btn img {
  flex: 0 0 auto;
}
.buy-btn:active {
  transform: scale(0.95);
}
.buy-icon {
  width: 0.28rem;
  margin-left: 0.15rem;
}
</style>



// WEBPACK FOOTER //
// src/page/aiResume.vue